import {
  FETCH_ORG_PEOPLE_REQUEST,
  FETCH_ORG_PEOPLE_SUCCESS,
  FETCH_ORG_PEOPLE_FAILURE,
  OrgPeopleState,
  OrgPerson,
} from '../types/onboarding';

interface Action {
  type: string;
  payload?: any;
}

const initialState: OrgPeopleState = {
  people: [],
  loading: false,
  error: null,
};

const orgPeopleReducer = (state: OrgPeopleState = initialState, action: Action): OrgPeopleState => {
  switch (action.type) {
    case FETCH_ORG_PEOPLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ORG_PEOPLE_SUCCESS:
      return {
        ...state,
        loading: false,
        people: action.payload,
        error: null,
      };

    case FETCH_ORG_PEOPLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default orgPeopleReducer;
